import { createSlotsContext } from "@grandvisionhq/slots";
const [AppointmentSummarySlotsProvider, useAppointmentSummarySlotsContext] = createSlotsContext({
  displayName: "AppointmentSummarySlotsContext"
});
export {
  AppointmentSummarySlotsProvider,
  useAppointmentSummarySlotsContext
};
//# sourceMappingURL=AppointmentSummarySlotsContext.js.map
